export default __webpack_public_path__ + "static/media/814.f2af110b.png";